export default {"src":"/_next/static/media/0xbbbbca6a901c926f240b89eacb641d8aec7aeafd.31b70940.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};